export default __webpack_public_path__ + "static/media/LineosoftADD (2)-min.99348803.PNG";